<script setup lang="ts">
import type { SaleAssetBusEntity } from '~/apiClient';
import type { PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
interface Props {
    sale: PlatformSaleItemEntity;
    assetId?: string;
}

const { sale, assetId } = defineProps<Props>();

// COMPOSABLES
const { isTrustReportEligible } = useTrustReport(() => sale);

// COMPUTED
const asset = computed<SaleAssetBusEntity | undefined>(() => sale.assets.find(_a => _a.id === assetId));
</script>

<template>
    <div v-if="asset" class="flex flex-col gap-6" :class="{ 'rounded-xl border border-neutral-300 p-6': !isTrustReportEligible }">
        <SdpGallery :key="asset.id" :sale="sale" :asset="asset" />

        <SdpMaybeTrustReportWrapper :sale="sale" :asset-id="assetId">
            <BaseI18nT v-if="!isTrustReportEligible" tag="h2" keypath="sdp.multi.detailTitle" class="text-2xl font-bold">
                <template #name>
                    <span class="text-primary">{{ asset.brand.brandValue }} {{ asset.model.modelValue }}</span>
                </template>
            </BaseI18nT>
            <SdpSpecs :sale="sale" :asset-id="assetId" />
            <SdpDetails :sale="sale" :asset-id="assetId" />
            <SdpDocuments :asset="asset" :sale="sale" />
        </SdpMaybeTrustReportWrapper>

        <MktgTrustReport />
    </div>
</template>
